module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }